import { configureStore } from '@reduxjs/toolkit';

import addToCompanyReducer from './slices/addToCompanySlice';
import authenticationReducer from './slices/authentication';
import colorModeReducer from './slices/colorModeSlice';
import confirmDialogReducer from './slices/confirmDialogSlice';
import filterReducer from './slices/filterSlice';
import fullScreenLoadingReducer from './slices/fullSrceenLoadingSlice';
import GeneralDialogReducer from './slices/generalDialogSlice';
import invalidTokenModalReducer from './slices/invalid-token-modal-slice';
import InvoiceDetailsDialogReducer from './slices/invoiceDetailsDialogSlice';
import itemsAddedDialogReducer from './slices/itemsAddedDialogSlice';
import LiveOrderDetailsDialogReducer from './slices/liveOrderDetailsDialogSlice';
import navigationReducer from './slices/navigation';
import pdfDialogReducer from './slices/pdfDialog';
import profileDialogReducer from './slices/profileEditorDialog';
import quotationActionsDialogReducer from './slices/quotationActionsDialogSlice';
import ShipmentLabelDetailsDialogReducer from './slices/shipmentLabelDetailsDialogSlice';
import sidebarNavigationReducer from './slices/sidebarNavigation';
import updateCartItemsReducer from './slices/updateCartItemsSlice';

export const store = configureStore({
    reducer: {
        invalidTokenModal: invalidTokenModalReducer,
        authentication: authenticationReducer,
        sidebarNavigation: sidebarNavigationReducer,
        colorMode: colorModeReducer,
        navigation: navigationReducer,
        profileDialog: profileDialogReducer,
        fullScreenLoading: fullScreenLoadingReducer,
        confirmDialog: confirmDialogReducer,
        invoiceDetailsDialog: InvoiceDetailsDialogReducer,
        addToCompanyDialog: addToCompanyReducer,
        updateCartItems: updateCartItemsReducer,
        quotationActionsDialog: quotationActionsDialogReducer,
        itemsAddedDialog: itemsAddedDialogReducer,
        liveOrderDetailsDialog: LiveOrderDetailsDialogReducer,
        generalDialog: GeneralDialogReducer,
        filter: filterReducer,
        shipmentLabelDetailsDialog: ShipmentLabelDetailsDialogReducer,
        pdfDialog: pdfDialogReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
